<template>
  <message-type-message
    class="forwarded"
    :message="message"
    :shown-subscription="shownSubscription"
    @openDocumentDrawer="openDocumentDrawer"
  />
</template>

<script>
import MessageTypeMessage from './MessageTypeMessage.vue';

export default {
  components: {
    MessageTypeMessage,
  },
  props: {
    message: {
      type: Object,
      default: null,
    },
    shownSubscription: {
      type: Object,
      default: null,
    },
  },
  methods: {
    openDocumentDrawer(data) {
      this.$emit('openDocumentDrawer', data);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use '../../../shared/assets/scss/core/variables' as *;
@use '../../../shared/assets/scss/core/breakpoints' as *;

.forwarded ::v-deep {
  .message {
    .sender-name {
      visibility: visible;
    }
    .message-body {
      background-color: $color-grey-base !important;
      color: var(--color-primary-darker) !important;
      &:after {
        border-right: 10px solid $color-grey-base !important;
      }
    }
  }
}
</style>
